import React, { useState } from 'react';
import { getUploadUrl } from '@/utils/api';
import { cn } from '@/lib/utils';

const getInitials = (firstName, lastName, fullName) => {
  if (firstName || lastName) {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  }
  if (fullName) {
    const parts = fullName.trim().split(/\s+/);
    return `${parts[0]?.[0] || ''}${parts[1]?.[0] || ''}`.toUpperCase();
  }
  return '';
};

/**
 * Global member avatar with initials fallback.
 * Shows the portrait photo when available, otherwise renders initials.
 */
export const MemberAvatar = ({
  photoUrl,
  firstName,
  lastName,
  fullName,
  size = 'md',
  className,
  'data-testid': testId,
}) => {
  const [errored, setErrored] = useState(false);

  const sizeClasses = {
    xs: 'w-8 h-8 text-xs',
    sm: 'w-10 h-10 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-2xl',
  };
  const dims = sizeClasses[size] || sizeClasses.md;
  const initials = getInitials(firstName, lastName, fullName);
  const showImage = photoUrl && !errored;

  if (showImage) {
    return (
      <img
        src={getUploadUrl(photoUrl)}
        alt={fullName || `${firstName || ''} ${lastName || ''}`.trim() || 'Member'}
        onError={() => setErrored(true)}
        className={cn(dims, 'rounded-full object-cover border-2 border-primary flex-shrink-0', className)}
        data-testid={testId}
      />
    );
  }

  return (
    <div
      className={cn(
        dims,
        'rounded-full bg-primary/10 flex items-center justify-center font-semibold text-primary border-2 border-primary/20 flex-shrink-0',
        className
      )}
      data-testid={testId}
    >
      {initials || <span className="opacity-60">?</span>}
    </div>
  );
};

export default MemberAvatar;
